import { DocumentGarmentPlacementType, GarmentPlacementXMLType } from 'src/types/decorationSpecs';
import { ScaleAxis } from 'src/util/autoPosition';

/**
 * Converts documents' `GARMENT_WARP` placement inputs to/from the PascalCase JSON shape stored
 * in a scene revision's `metadata.garmentPlacements` field. Like garment markers, this is
 * scene-maker bookkeeping (not part of the shared CIM/Dip XML schema — a `GARMENT_WARP`
 * document's transform is serialized as an ordinary `RectangleWarp`), so it rides alongside
 * the XML on the revision record rather than inside it.
 */

export type GarmentPlacementState = {
    GarmentPlacements: GarmentPlacementXMLType[];
};

export function fromState(placements: DocumentGarmentPlacementType[]): GarmentPlacementState {
    return {
        GarmentPlacements: placements.map((placement) => ({
            DocumentId: placement.id,
            BackgroundId: placement.backgroundId,
            PanelName: placement.panelName,
            ScaleAxis: placement.scaleAxis,
        })),
    };
}

export function toState(placements: GarmentPlacementXMLType[]): DocumentGarmentPlacementType[] {
    return placements.map((placement) => ({
        id: placement.DocumentId,
        backgroundId: placement.BackgroundId,
        panelName: placement.PanelName,
        scaleAxis: placement.ScaleAxis as ScaleAxis,
    }));
}
